<template>
  <main class="text-notification-picker">

    <div class="data-description" style="margin-top:30px">
      <b>select a notification message</b>

      <div>
        choose a message to send your members as a text, and we will include a secure link to the stashboard you've created above
      </div>
    </div>

    <sb-dropdown :items="templates" :selected="selected" v-on:update:selected="$emit('update:selected', $event)" style="width:100%">
      <template #label="{ selected }">
        <div v-if="!selected" class="notification-label">
          select a message
        </div>

        <template v-if="selected">
          <div class="notification-label">
            {{ selected.title }}
          </div>
          <div class="notification-label-description">
            {{ selected.message }}
          </div>
        </template>
      </template>

      <template #item="{ item }">
        <div class="notification-item">
          {{ item.title }}
        </div>
        <div class="notification-item-description">
          {{ item.message }}
        </div>
      </template>
    </sb-dropdown>
  </main>
</template>

<script>

export default {
  name: 'text-notification-picker',
  props: {
    selected: [ String, Number, Object ],
    templates: Array
  }
}
</script>

<style>
  .data-description b {
    font-size: 1.25rem;
  }
</style>
